import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import todayIconLight from '../assets/today-icon-light.svg';
import todayIconDark from '../assets/today-icon-dark.svg';
import analyticsIconLight from '../assets/analytics-icon-light.svg';
import analyticsIconDark from '../assets/analytics-icon-dark.svg';
import settingsIconLight from '../assets/settings-icon-light.svg';
import settingsIconDark from '../assets/settings-icon-dark.svg';
import exercisesIconLight from '../assets/exercises-icon-light.svg';
import exercisesIconDark from '../assets/exercises-icon-dark.svg';
import styles from './Footer.module.css';

const Footer = ({ darkMode }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  useEffect(() => {
    const initialHeight = window.innerHeight;

    const handleFocusIn = (e) => {
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
        setIsKeyboardOpen(true);
      }
    };

    const handleFocusOut = () => {
      setIsKeyboardOpen(false);
    };

    const handleResize = () => {
      const heightDiff = initialHeight - window.innerHeight;
      setIsKeyboardOpen(heightDiff > 100); // Порог уменьшен для большей чувствительности
    };

    window.addEventListener('focusin', handleFocusIn);
    window.addEventListener('focusout', handleFocusOut);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('focusin', handleFocusIn);
      window.removeEventListener('focusout', handleFocusOut);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isCurrentPage = (path) => location.pathname === path;

  return (
    <footer className={`${styles.footer} ${isKeyboardOpen ? styles.hidden : ''}`}>
      <div className={styles.container}>
        <button onClick={() => navigate('/home')} className={styles.navButton}>
          <img
            src={darkMode ? todayIconLight : todayIconDark}
            alt="Сегодня"
            className={`${styles.icon} ${isCurrentPage('/home') ? styles.active : ''}`}
          />
        </button>
        <div className={styles.divider}></div>
        <button onClick={() => navigate('/analytics')} className={styles.navButton}>
          <img
            src={darkMode ? analyticsIconLight : analyticsIconDark}
            alt="Аналитика"
            className={`${styles.icon} ${isCurrentPage('/analytics') ? styles.active : ''}`}
          />
        </button>
        <div className={styles.divider}></div>
        <button onClick={() => navigate('/exercises')} className={styles.navButton}>
          <img
            src={darkMode ? exercisesIconLight : exercisesIconDark}
            alt="Упражнения"
            className={`${styles.icon} ${isCurrentPage('/exercises') ? styles.active : ''}`}
          />
        </button>
        <div className={styles.divider}></div>
        <button onClick={() => navigate('/settings')} className={styles.navButton}>
          <img
            src={darkMode ? settingsIconLight : settingsIconDark}
            alt="Настройки"
            className={`${styles.icon} ${isCurrentPage('/settings') ? styles.active : ''}`}
          />
        </button>
      </div>
    </footer>
  );
};

export default Footer;